/* template */
<template minapp="mpx" xlang="wxml"><controllable-drawer-bottom title="权益说明" :show="(show)" :headerStyle="(headerStyle)" :iconStyle="(iconStyle)" @close="closeDrawer"><div class="container"><span class="description">{{ descriptionContent }}</span></div></controllable-drawer-bottom></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4c54b8b8"}'>
  .container
    width 100%
    margin-top 24px
    padding 0 12px
    padding-bottom 159px
    box-sizing border-box
    .description
      font-family PingFangSC-Regular
      font-weight 400
      line-height 17px
      font-size 12px
      color #666
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4c54b8b8"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./rights-description-drawer.mpx.js?isComponent&outputPath=components%2Frights-description-drawer4c54b8b8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./rights-description-drawer.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Frights-description-drawer4c54b8b8%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m4c54b8b8"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/rights-description-drawer4c54b8b8/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'controllable-drawer-bottom':getComponent(require("../../../components/controllable-drawer-buttom.mpx?isComponent&outputPath=components%2Fcontrollable-drawer-buttomcb57d2b4%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
